import InfoItem from '../common/InfoItem'
import { useTranslation } from '../../lib/i18n'

const PostInEmpty = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col w-full mb-4 px-2 md:px-0">
      <div className="bg-white rounded-lg p-4 mb-4">
        <p className="text-sm text-gray-600 my-1">{t('post.empty.message')}</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 w-full mb-2">
        {t('post.empty.infoItems').map((item, index) => (
          <InfoItem
            key={index}
            href={item.href}
            icon={item.icon}
            title={item.title}
            bgColor={item.bgColor}
            text={item.text}
          />
        ))}
      </div>
    </div>
  )
}

export default PostInEmpty
